import {
	StyledShareButton,
	StyledShareButtonContainer,
	StyledShareButtonLink,
} from 'components/Selfiebooth/ShareDisplay/styled'
import { FiDownload } from 'react-icons/fi';
import React, { useState } from 'react'
import timestamp from 'time-stamp'
import Spinner from 'components/Spinner'
import { ShareDownloadSelfieBoothType } from '../../../types/selfiebooth'
import { withTranslation } from 'react-i18next'

interface DownloadProps {
	share: ShareDownloadSelfieBoothType;
	finalImg: string;
	t: any
}

const Download = ({ share, finalImg, t }: DownloadProps) => {
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const handleDownload = () => {
		if (!finalImg) return;

		setIsLoading(true)

		const base64Data = finalImg.split(',')[1];
		const byteCharacters = atob(base64Data);
		const byteArrays = [];

		for (let i = 0; i < byteCharacters.length; i++) {
			byteArrays.push(byteCharacters.charCodeAt(i));
		}

		const blob = new Blob([new Uint8Array(byteArrays)], { type: "image/png" });
		const blobUrl = URL.createObjectURL(blob);

		const a = document.createElement('a');
		a.href = blobUrl;
		a.download = `Photo-${timestamp('YYYY-MM-DD-HH:mm:ss')}.jpg`
		document.body.appendChild(a);
		a.click();

		URL.revokeObjectURL(blobUrl);

		setIsLoading(false)
	};

	return (
		<StyledShareButtonContainer $isSpinner={false}>
			<StyledShareButton $type="copyLink" onClick={handleDownload}>
				<i>{isLoading ? <Spinner isLoading={isLoading} style={{ top: '10px', left: '10px' }} /> : <FiDownload />}</i>
				<label>{share.label || t('photobooth.download')}</label>
			</StyledShareButton>
		</StyledShareButtonContainer>
	);
};

export default withTranslation()(Download);
